import $ from "jquery";

const GutenbergImage = (el) => {
    const $el = $(el);
    let figures = $el.find("figure");
    
    figures.map((index, item) => {
        const figure = $(item);
        const image = figure.find("img");
        const imageWidth = image.width();

        figure.css("maxWidth", imageWidth + "px");
    });
};

export default GutenbergImage;
